import { render } from "./PatientMedicalRecordEntry.vue?vue&type=template&id=0dbd86d8"
import script from "./PatientMedicalRecordEntry.vue?vue&type=script&lang=js"
export * from "./PatientMedicalRecordEntry.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__